import React from 'react';
import { get } from 'lodash';
import { getComponentVersionProps } from '../../../../utils/helpers';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';

const CampaignDetailV1 = asyncRoute(() => import('./v1'));
const CampaignDetailV2 = asyncRoute(() => import('./v2'));

const CampaignDetail = (props) => {
  const { themeData } = props;
  const componentProps = getComponentVersionProps(themeData, 'campaign-reward');

  const version = get(componentProps, 'version', 'cv1');
  const style = get(componentProps, 'style', {});
  switch (version) {
    case 'cv1':
      return <CampaignDetailV1 {...props} style={style} />;
    case 'cv2':
      return <CampaignDetailV2 {...props} style={style} />;
    default:
      return <CampaignDetailV1 {...props} style={style} />;
  }
};

export default CampaignDetail;
